import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Subscription, of, Observable } from 'rxjs';
import { map, catchError, take } from 'rxjs/operators';

import { LoggingMessageService } from './logging-message.service';
import { DataResult } from '../models/data-result.mode';
import { AuthService } from './auth.service';
import { SubscriptionChangeService } from './subscription-change.service';


@Injectable({
    providedIn: 'root'
})
export class HospitalChangeService implements OnInit, OnDestroy {
    private $subscriptions: Subscription = new Subscription();
    private _NO_DATA = { message: '' };

    constructor(private http: HttpClient, private authService: AuthService, private logger: LoggingMessageService, private subscriptionService: SubscriptionChangeService) {
    }

    ngOnInit(): void {

    }

    public changeHospitalId(service: string, hospid: string, useTest: boolean): Observable<DataResult> {
        const webmethod = (useTest === true) ? '/HospitalTest' : '/Hospital';
        const media = 'application/json';
        // const media = 'text/plain';
        const id = Number(hospid);
        const uri = `${service}${webmethod}`;
        const hospModel = { hospitalID: id, message: '' };

        this.logger.debug('hospital-change.service', 'changeHospitalId',  this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  `calling url: ${uri}`, '');
        return this.http.post<DataResult>(uri, hospModel,
            {
                headers: { Accept: media },
                observe: 'response'
            }
        )
            .pipe(
                map(response => {
                    let result: DataResult;
                    if (response instanceof HttpResponse) {
                        const respBody: any = response.body;
                        hospModel.message = respBody.message;
                        hospModel.hospitalID = respBody.hospitalID;
                        if (response.status === 200) {
                            result = new DataResult(response.ok, response.status, response.statusText, hospModel);
                        } else if (response.status === 401) {
                            result = new DataResult(false, 401, response.statusText, hospModel);
                        } else {
                            result = new DataResult(false, 400, response.statusText, hospModel);
                        }
                    }
                    if (response instanceof HttpErrorResponse) {
                        hospModel.message = response.message;
                        result = new DataResult(false, 500, response.statusText, hospModel);
                    }
                    return result;
                }),
                catchError(error => {
                    this.logger.warn('hospital-change', 'changeHospitalId',  this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, 'Error caught', '');
                    const message = this.getErrorMessage(error);
                    return this.handleChangeHospitalError(`changeHospitalId failed`, message);
                }),
                take(1),
            );
    }

    private getErrorMessage(error: any): string {
        let message = error.message;
        if ((error.error) && (error.error.message)) {
            message = error.error.message;
        }
        return message;
    }

    private handleChangeHospitalError(operation: string, error: any) {
        let result: any;
        const response = this._NO_DATA;
        this.logger.warn('hospital-change', 'handleChangeHospitalError', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  `Operation:${operation}`, `Server Error:${error}`);
        response.message = error;
        const errorResult = new DataResult(false, 503, 'Service Unavailable error', response);
        result = errorResult;

        return of(result);
    }

    // private logMessage(level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR', message: string) {
    //     setTimeout(() => {
    //         const user = this.authService.getUser();
    //         switch (level) {
    //             case 'DEBUG':
    //                 this.logger.debug('hospital-change', 'HospitalChangeService', message, '');
    //                 break;
    //             case 'INFO':
    //                 this.logger.info(user, 'HospitalChangeService', message);
    //                 break;
    //             case 'WARN':
    //                 this.logger.warning(user, 'HospitalChangeService', message);
    //                 break;
    //             case 'ERROR':
    //                 this.logger.error(user, 'HospitalChangeService', message);
    //                 break;
    //             default:
    //                 break;
    //         }
    //     }, 0);
    // }

    unsubscribe() {
        if (this.$subscriptions) {
            this.$subscriptions.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }
}

